export const DEM_URL = 'https://tiles.mapterhorn.com/{z}/{x}/{y}.webp'
export const DEM_TILE_SIZE = 512
export const DEM_MAX_ZOOM = 16
// Max zoom for the 3D terrain *mesh* only. Capped below DEM_MAX_ZOOM to reduce
// mesh tessellation cost (smoother pan/zoom/rotate). Derived layers (slope
// angle, sun exposure, hillshade, contours) keep DEM_MAX_ZOOM for full fidelity.
export const TERRAIN_MESH_MAX_ZOOM = 13
